export default "__VITE_ASSET__K8IzZW4___"